import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { JSX } from 'react';
import { UserRole } from '../types/UserRole';

export const AdminProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (currentUser.role === UserRole.Buyer) {
    return <Navigate to="/" />;
  }
  if (currentUser.role === UserRole.Seller) {
    return <Navigate to="/" />;
  }
  if (currentUser.role === UserRole.Farmer) {
    return <Navigate to="/" />;
  }
  if (currentUser.role === UserRole.Admin) {
    return children;
  }
  
  return children;
};